export default __webpack_public_path__ + "static/media/expenses.fa373525.svg";